import { formatTimestampHuman } from "../date-utils";
export const weightItemDtoFields = [{
        name: "ingressDate",
        title: "Ingresso",
        render: (record) => formatTimestampHuman(record.slaughterWeight.createdOn)
    }, {
        name: "protocol",
        title: "Macellazione",
        render: (record) => record.slaughterProtocol
    }, {
        name: "ordinal",
        title: "Progressivo Mac.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.slaughterWeight.ordinal
    }, {
        name: "dailyOrdinal",
        title: "Progressivo Giorn.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.slaughterWeight.dailyOrdinal
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.lotNumber
    }, {
        name: "srcProductTypeName",
        title: "Tipologia Ingresso",
        render: (record) => record.srcProductTypeName
    }, {
        name: "dstProductTypeName",
        title: "Tipologia Uscita",
        render: (record) => record.dstProductTypeName
        // }, {
        //   name: "utilizationDescription",
        //   title: "Utilizzo",
        //   render: (record: IWeightLabelDTO) => record.utilizationDescription
        // }, {
        //   name: "utilizationNotes",
        //   title: "Note Utilizzo",
        //   render: (record: IWeightLabelDTO) => record.utilizationNotes
        // }, {
        //   name: "weighted",
        //   title: "Pesato",
        //   titleClass: "has-text-centered",
        //   dataClass: "has-text-centered",
        //   render: (record: IWeightLabelDTO) => `<i class="material-icons">${record.slaughterWeight.weighted === 1 ? "check" : ""}</i>`
    }, {
        name: "weight",
        title: "Peso",
        render: (record) => record.slaughterWeight.weighted == 1 ? record.slaughterWeight.weight : '--'
    }, {
        name: "printed",
        title: "Stampato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.slaughterWeight.printed === 1 ? "check" : ""}</i>`
    }];
